module.exports = __webpack_public_path__ + "img/src/modules/web-agent/assets/img/maven-logo.png?39b9da43fe3e4ac2fc7a9d718f4a87d3";